export const DOCUMENT_NOT_IN_HOMOLOGATION_MESSAGE = 'Este documento não está mais em homologação.';
export const RECORD_NOT_IN_HOMOLOGATION_MESSAGE = 'Este registro não está mais em homologação.';
